export const sl = {
  homePage: {
    helloWorld: 'Hi, how you doin?',
    countable: 'no count | one count | 2nd thing | {count} thingy',
    variablesOne: 'First var: {0}, Second var: {1}'
  },
  'homePage.variablesTwo': 'First var: {one}, Second var: {two}',
  nav: {
    model: 'Modeli',
    details: 'Podrobnosti',
    summary: 'Povzetek',
    preview: 'Zaključek',
  },
  footer:{
    total: 'Skupaj: {price} (brez DDV)',
    next: 'Naprej',
    submit: 'Na plačilo',
    finish: 'Oddaj povpraševanje',
    back: 'Nazaj'
  },
  model: {
    selectModel: 'Izberite model'
  },
  details: {
    editItem: 'Oblikujte svoj stol',
    tooltip: `Izbrani material je na voljo samo na zahtevo. Vabimo Vas, da si vzorce ogledate na povezavi: <a href="https://vez-sedezi.si/moznosti-katalog/" target="#" class="underline">https://vez-sedezi.si/moznosti-katalog/</a> in nas kontaktirate, da skupaj izberemo najboljšo možnost za vas.`,
    tooltipOk: 'OK',
    noBackrestUpholstery: 'Brez oblazinjenega naslona',
    backrest: 'Naslon',
    upholstered: 'Oblazinjenje',
    notUpholstered: 'Brez oblazinjenja',
    options: 'ni možnosti | 1 možnost | {options} možnosti',
    loadingModel: 'Izris v teku...',
    colorWarning: 'Barvni vzorci na računalniku lahko odstopajo od dejanskega stanja.'
  },
  maps: {
    bugy: {
      legs: 'Noge',
      seat: 'Sedalo',
      seatingAndBackrest: 'Oblazinjenje'
    },
    barly: {
      legs: 'Noge',
      seat: 'Sedalo',
      seatingAndBackrest: 'Oblazinjenje'
    },
    barman: {
      seat: 'Sedalo',
      seatingAndBackrest: 'Oblazinjenje'
    },
    kuki: {
      legs: 'Noge',
      seat: 'Sedalo',
      seatingAndBackrest: 'Oblazinjenje'
    },
    praktik: {
      seat: 'Sedalo',
      seatingAndBackrest: 'Oblazinjenje'
    },
    scorpio: {
      legs: 'Noge',
      seat: 'Sedalo',
      seatingAndBackrest: 'Oblazinjenje',
      legsShape: 'Oblika nog'
    }
  },
  summary: {
    summary: 'Povzetek',
    send_inquiry: 'Pošljite povpraševanje',
    message: 'Možen je tudi nakup posameznega stola. V kolikor so vaše želje drugačne se cena spremeni glede na izbor materialov in količino. Vaše želje dodajte v komentar.',
    remove: 'Odstrani',
    edit: 'Uredi',
    duplicate: 'Podvoji',
    addNewProduct: 'Dodaj nov stol',
    card: {
      pricePerItem: '{price} / stol (brez DDV)'
    }
  },
  preview: {
    summary: 'Zaključek',
    vatBasis: 'DDV osnova',
    vat: 'DDV',
    totalPrice: 'Skupaj',
    yourInfo: 'Vaši podatki',
    delivery: 'Dostava',
    freeDelivery: 'Pošlji povpraševanje na ',
    payment: 'Plačilo',
    price: {
      free: 'Brezplačna dostava',
      formatted: '{price}'
    },
  },
  done: {
    thankYou: 'Zahvaljujemo se vam za zaupanje!',
    done1: 'Vaše povpraševanje smo sprejeli.',
    done2: 'Želite izvedti več o Vez stolih po meri?',
    done3: 'Vabimo vas da obiščete našo spletno stran.',
    back: 'Naprej na spletno stran'
  },
  inputs: {
    comment: 'Komentarji',
    firstName: 'Ime',
    lastName: 'Priimek',
    phone: 'Telefon',
    mail: 'Email',
    address: 'Naslov',
    post: 'Pošna številka',
    city: 'Pošta',
    businessReceipt: 'Račun na podjetje',
    taxId: 'ID za DDV',
    company: 'Naziv podjetja'
  },
  errors: {
    firstName: 'Ime je obvezno',
    firstNameLength: 'Ime mora vsebovati vsaj {length} znakov',
    lastName: 'Priimek je obvezen',
    lastNameLength: 'Priimek mora vsebovati vsaj {length} znakov',
    phone: 'Telefonska številka je obvezna',
    phoneValid: 'Telefonska številka ni pravilne oblike',
    mail: 'Email je obvezen',
    mailValid: 'Email ni veljaven',
    address: 'Naslov je obvezen',
    post: 'Poštna številka je obvezna',
    city: 'Pošta je obvezna',
    taxId: 'DDV številka je obvezna',
    company: 'Naziv podjetja je obvezen',
    delivery: 'Dostava je obvezna'
  },
  payment:{
    later: 'Samo povpraševanje',
    now: 'Želim naročiti in plačati'
  }

};

export const currencySlSI = {
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol'
  }
}
